import lottie from "lottie-web";

export async function handleLottieAnime(container, json, option = {}) {
    const timestamp = Math.floor(new Date().getTime() / 1000);

    const animation = lottie.loadAnimation({
        container: container,
        renderer: "canvas",
        autoplay: false,
        path: `../assets/lottie/${json}.json?${timestamp}`,
        ...option,
    });

    // Lottie のメタデータを取得してズレを補正
    animation.addEventListener("DOMLoaded", () => {
        const fr = animation.animationData.fr; // フレームレート
        const op = animation.animationData.op; // 総フレーム数
        const animationDuration = op / fr; // 本来のアニメーション時間

        // console.log(op)

        // CSS の `targetDuration` と比較して速度補正
        if (option.targetDuration) {
            const speed = animationDuration / option.targetDuration;
            animation.setSpeed(speed);
            // console.log(`Lottie Speed Adjusted: ${speed}`);
        }
    });

    return animation;
}
